const awsBucketName = process.env.REACT_APP_AWS_BUCKET_NAME
const awsRegion = process.env.REACT_APP_AWS_REGION
const constants = {
  s3Bucket: `https://${awsBucketName}.s3.${awsRegion}.amazonaws.com/assets`,
};

export default constants;
